<template>
    <div class="flex-column dropdown-search">
        <el-dropdown trigger="click" @command="setValue">
            <el-input
                readonly
                class="wp-10"
                :value="pref.label"
                :placeholder="$t.__('inputs.custom.DropdownSearch.select_preference_to_update')"
                suffix-icon="el-icon-arrow-down"
            />
            <template #dropdown>
                <el-dropdown-menu class="pt-0 dropdown-search-dropdown-menu">
                    <div class="pt-2 pb-2 pl-3 pr-3 gray-0-bkg">
                        <el-input
                            class="input-search-dropdown"
                            :placeholder="$t.__('inputs.custom.DropdownSearch.search')"
                            v-model="searchInput"
                        >
                            <template #suffix>
                                <i class="el-input__icon icon-search" />
                            </template>
                        </el-input>
                    </div>
                    <div class="gray-60 fs-3 semibold p-3">
                        <span>{{ $l10n.__('Informations') }}</span>
                    </div>
                    <el-dropdown-item
                        v-for="item in search"
                        v-if="!item.isSelected"
                        :command="item"
                        class="gray-100"
                        :key="item.name"
                    >
                        {{ item.label }}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
    </div>
</template>

<script>
export default {
    props: ['value', 'pref'],
    data() {
        return {
            searchInput: '',
        };
    },
    computed: {
        search() {
            let metaFiltered = Object.values(this.value);
            if (this.searchInput === '' && !this.searchInput) {
                return this.value;
            } else {
                metaFiltered = metaFiltered.filter((item) => {
                    return item.label.toLowerCase().includes(this.searchInput.toLowerCase());
                });
                return metaFiltered;
            }
        },
    },
    methods: {
        setValue(command) {
            this.$emit('onMetaSelected', command);
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.dropdown-search {
    .input-search-dropdown {
        background-clip: padding-box;
    }

    .el-dropdown .el-input.el-input--suffix {
        input {
            cursor: pointer;
        }

        .el-input__suffix {
            color: $gray-100;
        }
    }

    .popper__arrow {
        left: 10% !important;
    }
}

.el-dropdown-menu.el-popper.dropdown-search-dropdown-menu {
    width: 416px;

    .input-search-dropdown.el-input.el-input--suffix {
        .el-input__suffix {
            padding-right: 12px;
        }
    }
}
</style>
